import React from 'react';

import cx from '@travel/icons/_utils/classnames';
import { AwardJapanStandardLarge } from '@travel/icons/award';
import { Close } from '@travel/icons/ui';
import Translate from '@travel/traveler-core/components/Translate';
import { useDeviceType, MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import { FlatButton } from '@travel/ui';

import Dialog from '../Dialog';

import styles from './japanStandardPopup.module.scss';

type Props = {
  isUsedForSEO?: boolean;
  isOpen?: boolean;
  onCloseCallback?: () => void;
};

function JapanStandardPopup(props: Props) {
  const { isUsedForSEO, isOpen, onCloseCallback } = props;
  const isSP = useDeviceType() === MOBILE_SCREEN;

  return (
    <div>
      <Dialog
        isOpen={isOpen}
        isClosableByClickingOutside={true}
        isHideCloseButtonDialog={true}
        isSEOContentIndexedOnHidden={isUsedForSEO}
        onClose={onCloseCallback}
        className={styles.japanStandardDialog}
        contentClassName={styles.japanStandardContentBox}
        dialogWrapperClassName={styles.dialogWrapper}
        hasAnimation={true}
      >
        {!isSP && (
          <button
            className={cx(styles.closePopup)}
            onClick={onCloseCallback}
            aria-label="Close menu"
            data-testid="header-close-button"
          >
            <Close size={24} />
          </button>
        )}
        <div
          className={styles.japanStandardContentWrapper}
          data-testid="japanStandardContent-wrapper"
        >
          <div>
            <AwardJapanStandardLarge />
          </div>
          <div>
            <div className={styles.h6Bold}>
              <Translate id="Traveler_Common.Japan_Quality.Intro_Title1" />
            </div>
            <div className={styles.h3Bold}>
              <Translate id="Traveler_Common.Japan_Quality.Intro_Title2" />
            </div>
          </div>
          <div className={cx(styles.b1, styles.bottomGap)}>
            <Translate id="Traveler_Common.Japan_Quality.Description" />
          </div>
          <div>
            <FlatButton
              classType="primary"
              onClick={onCloseCallback}
              className={styles.closeButton}
              data-testid="japanStandard-close-button"
            >
              <Translate id="Traveler_Common.Close" />
            </FlatButton>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default React.memo(JapanStandardPopup);
